import { useResizeObserver, useFloatingScrollbar } from "@tellescope/react-hooks";

/**
 * Wires a scroll container up as a floating-scrollbar surface: an overlaid thumb that fades in on
 * scroll, and an `isOverflowing` flag for fading the clipped bottom edge.
 *
 * Attach `scrollRef` and `handleScroll` to the scrolling element, and `thumbRef` to a thumb rendered
 * inside a `relative` parent.
 */
export const useScrollSurface = () => {
  const { scrollContainerRef, thumbRef, handleScroll } = useFloatingScrollbar<HTMLDivElement>();

  const { ref, value: isOverflowing } = useResizeObserver<boolean, HTMLDivElement>(
    (element) => element.scrollHeight > element.clientHeight + 1,
    false
  );

  // Fans the one element out to both the overflow observer and the floating scrollbar.
  const scrollRef = (element: HTMLDivElement | null) => {
    ref.current = element;
    scrollContainerRef.current = element;
  };

  return { isOverflowing, scrollRef, thumbRef, handleScroll };
};
